define(['edge/platform/viewmodel/ViewModel',
    './Context',
    './Requiredness',
    './Validity',
    './SubtreeValidity',
    './InputCtrlType',
    './AvailableValues',
    './SerializedForm',
    './RebuildVMFromData',
    './DebugInvalidChildProperties',
    './TypedValue',
    './_ValidationFunctions',
    'edge/platform/util/DateUtil',
    'edge/platform/util/PhoneUtil',
    'edge/platform/util/LocalDateUtil',
    'edge/platform/el/module',
    'edge/platform/viewmodel/module',
    'l10nModule'
], (ViewModel, Context, Requiredness, Validity, SubtreeValidity, InputCtrlType, AvailableValues, SerializedForm,
    RebuildVMFromData, DebugInvalidChildProperties, TypedValue, _ValidationFunctions, DateUtil, _PhoneUtil, LocalDateUtil)=> {
    return angular.module('edge.platform.viewmodel.aspects', ['edge.platform.el', 'edge.platform.viewmodel'])
        .run(['ViewModelService', 'ExpressionLanguageService', 'TranslateService', 'LocaleService', 'DateFormatter',
            (ViewModelService, ExpressionLanguageService, TranslateService, LocaleService, DateFormatter)=> {
                const typeValidationMessages = {};

                TranslateService.translate({
                    'object': typeValidationMessages,
                    'displayKey': 'platform.modelvalidation.DTOValidationService.Please enter numbers only',
                    'propName': 'notANumber'
                });
                TranslateService.translate({
                    'object': typeValidationMessages,
                    'displayKey': 'platform.modelvalidation.DTOValidationService.Value entered must not contain decimal values',
                    'propName': 'notAnInteger'
                });

                // this ensures support for ViewModels in Karma test runs
                ViewModelService.resetAspectFactories();
                ViewModelService.addAspectFactory(Context.create(ExpressionLanguageService));
                ViewModelService.addAspectFactory(Requiredness.create(ExpressionLanguageService));
                ViewModelService.addAspectFactory(Validity.create(ExpressionLanguageService, typeValidationMessages));
                ViewModelService.addAspectFactory(SubtreeValidity);
                ViewModelService.addAspectFactory(InputCtrlType);
                ViewModelService.addAspectFactory(AvailableValues.create(ExpressionLanguageService));
                ViewModelService.addAspectFactory(SerializedForm);
                ViewModelService.addAspectFactory(RebuildVMFromData);
                ViewModelService.addAspectFactory(DebugInvalidChildProperties);
                ViewModelService.addAspectFactory(TypedValue);

                ExpressionLanguageService.getCompilationContext().registerType('edge.aspects.validation.ValidationFunctions', _ValidationFunctions(LocaleService));
                ExpressionLanguageService.getCompilationContext().registerType('edge.capabilities.locale.util.DateFormatter', DateFormatter);
                ExpressionLanguageService.getCompilationContext().registerType('gw.api.util.DateUtil', DateUtil);
                ExpressionLanguageService.getCompilationContext().registerType('gw.api.util.PhoneUtil', _PhoneUtil(LocaleService));
                ExpressionLanguageService.getCompilationContext().registerType('edge.time.LocalDateUtil', LocalDateUtil);
            }]);
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/viewmodel/aspects/module.js